module.exports = __webpack_public_path__ + "5f0c20d144ed5a2ade328225d9f44d29.svg";